module.exports = __webpack_public_path__ + "img/bg-left-diamond.f7fcba7.png";